import { useTranslation } from "react-i18next";

import { Card, CardBody, CardHeader } from "@/components/ui/Card";
import type { ArchiveSummary } from "@/lib/api";
import { formatMonthYear, formatNumber } from "@/lib/format";

function Figure({ value, label }: { value: number; label: string }) {
  return (
    <div className="flex min-w-0 flex-col-reverse sm:border-l sm:border-line sm:px-5 sm:first:border-l-0 sm:first:pl-0">
      <dt className="text-sm text-ink-muted">{label}</dt>
      <dd className="text-[1.9rem] leading-tight font-semibold tracking-tight tabular-nums">
        {formatNumber(value)}
      </dd>
    </div>
  );
}

export function ArchiveSummaryCard({ summary }: { summary: ArchiveSummary }) {
  const { t } = useTranslation();
  return (
    <Card aria-labelledby="archive-summary-title">
      <CardHeader title={<span id="archive-summary-title">{t("archive.title")}</span>} />
      <CardBody className="space-y-5">
        <dl className="flex flex-col gap-4 sm:flex-row sm:gap-0">
          <Figure value={summary.tickets} label={t("archive.tickets")} />
          <Figure value={summary.articles} label={t("archive.articles")} />
          <Figure value={summary.queues} label={t("archive.queues")} />
        </dl>
        {summary.first_ticket_at && summary.last_ticket_at && (
          <p className="border-t border-line pt-4 text-sm text-ink-muted">
            <span className="font-medium text-ink">{t("archive.period")}</span>{" "}
            {t("archive.periodRange", {
              from: formatMonthYear(summary.first_ticket_at),
              to: formatMonthYear(summary.last_ticket_at),
            })}
          </p>
        )}
      </CardBody>
    </Card>
  );
}
